import { render, staticRenderFns } from "./LatestBusinessOffer.vue?vue&type=template&id=675a3382"
import script from "./LatestBusinessOffer.vue?vue&type=script&lang=js"
export * from "./LatestBusinessOffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports